
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

interface UsersHeaderProps {
  onNewUser: () => void;
}

export function UsersHeader({ onNewUser }: UsersHeaderProps) {
  return (
    <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
      <div>
        <h2 className="text-2xl font-bold tracking-tight text-foreground">Usuários</h2>
        <p className="text-muted-foreground">
          Gerencie os usuários da sua organização.
        </p>
      </div>
      <Button 
        onClick={onNewUser}
        className="bg-primary hover:bg-primary/90"
      >
        <Plus className="mr-2 h-4 w-4" /> Novo Usuário
      </Button>
    </div>
  );
}
